const SavedSearches = () => {
  return (
    <div>
      <p className="text-xs text-[#898CA8]">Búsquedas guardadas</p>

      <div className="mt-2.5 flex gap-3 overflow-x-auto">
        <button className="w-[220px] p-4 border border-[#EBEDF0] rounded-xl text-left">
          <p className="text-[10px] text-[#898CA8]">Julio 23, 2023</p>
          <p className="text-sm text-text-primary mt-2">Venta, casa grande</p>
          <p className="text-sm text-[#898CA8] truncate">
            3+ habitaciones, 3+ baños, 4 amenidades
          </p>
        </button>

        <button className="w-[220px] p-4 border border-[#EBEDF0] rounded-xl text-left">
          <p className="text-[10px] text-[#898CA8]">Julio 23, 2023</p>
          <p className="text-sm text-text-primary mt-2">Renta, departamento</p>
          <p className="text-sm text-[#898CA8] truncate">
            1 habitación, 1 baño, 4 amenidades
          </p>
        </button>
      </div>
    </div>
  )
}

export default SavedSearches
